<div class="popup-boxes">
  <form [formGroup]='form'>
    <div class="modal-header header-m">
      {{ modalFormTile }}
      <button type="button" class="close" data-dismiss="modal" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
        <span class="sr-only">Close</span>
      </button>
    </div>
    <div class="sub-title" ng-class="{'alert-danger': hasIssue > 0, 'alert-info': hasIssue == 0}">{{ modalFormText }}</div>
    <div class="inner-modal-content tab-contents">
      <div class="group inputfrom">
        <input ng-model="role_name" formControlName="role_name" type="text" class="form-control font-bold" id="" placeholder="Name" ng-keypress="role_keypress()"
          ng-enter-prevent-default required="required">
        <span class="bar"></span>
        <label>Name</label>
        <app-field-error-display [displayError]="isFieldValid('role_name')" errorMsg="Please provide role name!">
        </app-field-error-display>
      </div>
      <div class="group inputfrom">
        <textarea ng-model="role_desc" name="role_desc" type="text" class="form-control font-bold" id="" placeholder="Description" required
          ng-keypress="role_keypress()" required="required"></textarea>
        <span class="bar"></span>
        <label>Description</label>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" (click)="cancel()">CANCEL</button>
      <button ng-hide="showedit" class="btn btn-primary" (click)="addOrEdit()" id="saveBtn">CONFIRM</button>
      <button ng-show="showedit" class="btn btn-primary" (click)="addOrEdit()" id="editBtn">CONFIRM</button>
    </div>
  </form>
</div>
